import { ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { FollowersGrowthPeriodEnum, useTrendingInstagramInfluencersV2Query } from '@anytag/graphql';
import {
  TrendingInfluencersList,
  TrendingInfluencersTabType,
  useTrendingInfluencersFilter,
  TrendingInfluencerProfileType
} from '@anytag/shared-organisms';

export const TrendingInstagramInfluencers = () => {
  const { page, limit, filter } = useTrendingInfluencersFilter();
  const { data, loading } = useTrendingInstagramInfluencersV2Query({
    fetchPolicy: 'cache-and-network',
    variables: getValuableVariables({
      limit,
      countryId: filter.countryId,
      offset: getOffset(page, limit),
      categoryIds: filter.categoryIds.map(Number),
      minFollowers: filter.minFollowers ? Number(filter.minFollowers) : null,
      followerGrowthPeriod: filter.followerGrowthPeriod as FollowersGrowthPeriodEnum
    })
  });

  const trendingInfluencers = data?.trendingInstagramInfluencersV2;
  const totalRecords = trendingInfluencers?.totalNumber;
  const listRecords: TrendingInfluencerProfileType[] =
    trendingInfluencers?.trendingAccounts.map((infl) => ({
      ...infl,
      popularPosts: infl.popularPosts?.map(({ postId, thumbNail, type }) => ({ id: postId, thumbNail, type })) || []
    })) || [];

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <TrendingInfluencersList
        loading={loading}
        data={listRecords}
        totalRecords={totalRecords}
        tab={TrendingInfluencersTabType.INSTAGRAM}
      />
    </ListWithPagination>
  );
};
